<template>
  <div id="app">
     <!-- <el-scrollbar style="width:100%;height: calc(100% - 0px);"> -->
      <router-view></router-view>
     <!-- </el-scrollbar> -->
  </div>
</template>

<style lang="scss">
.el-message-box{
  width: 385px;
  background: #FFFFFF;
  box-shadow: 0px 9px 33px 0px rgba(22, 25, 27, 0.05);
  border-radius: 4px;
  .el-message-box__title {
    padding-left: 0;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 1;
    color: #303133;
  }

  .el-message-box__btns {
    padding: 5px 31px 0;
    text-align: center;
    .el-button{
      width: 132px;
      height: 42px;
      box-shadow: 0px 6px 7px 0px rgba(16, 104, 137, 0.11);
      border-radius: 21px;
      border: 1px solid #002B9C;
    }
    .el-button--primary{
      float: left;
      width: 132px;
      height: 42px;
      background:#002B9C;
      box-shadow: 0px 6px 7px 0px rgba(16, 104, 137, 0.11);
      border-radius: 21px;
      border: 1px solid #002B9C;

    }
  }
}



.page-pagination {
    /*margin-top: 14px !important;*/
    /*padding-bottom: 14px !important;*/
    display: flex !important;
    //justify-content: center;
    position: relative !important;
    flex-direction: row !important;
    justify-content: space-between !important;

    .pageRight {
        float: right !important;
        margin-left: 19px !important;
        line-height: 32px !important;
        color: #2F2F42 !important;
        opacity: 0.6 !important;
        font-size: 13px !important;
    }


    //设置分页在左显示
    /deep/ .el-pagination__sizes {
        float: right !important;
    }

    .el-pager {
        color: #4C5CBB !important;

        li {
            font-weight: 400 !important;
            background: #E5E5ED !important;
        }

        li.active {
            background-color: #002b9c !important;
            color: #fff !important;
            min-width: 30px !important;
            padding: 0 !important;
        }
    }

    /deep/ .el-pager {
        color: #002b9c !important;

        li {
            font-weight: 400 !important;
            background: #E5E5ED !important;
        }

        li.active {
            background-color: #161C26 !important;
            border-radius: 50% !important;
            color: #fff !important;
            min-width: 30px !important;
            padding: 0 !important;
        }
    }


    /deep/ .btn-prev, /deep/ .btn-next {
        background: #E5E5ED !important;
    }

    /deep/ .el-pagination__sizes {
        .el-input {
            width: 80px !important;
        }

        .el-input__inner {
            background: #E5E5ED !important;
            padding: 0 !important;
            border-radius: 15px !important;
            color: #859DA9 !important;
        }

        .el-input__suffix {
            display: none !important;
        }
    }

    .el-pagination__sizes {
        .el-input {
            width: 80px !important;
        }

        .el-input__inner {
            background: #E5E5ED !important;
            padding: 0 !important;
            color: #859DA9 !important;
        }

        .el-input__suffix {
            display: none !important;
        }
    }

    .el-select .el-input.is-focus .el-input__inner {
        border-color: #002b9c !important;
    }

    .el-pagination__sizes .el-input .el-input__inner:hover {
        border-color: #002b9c !important;
    }

    .el-pagination.is-background .btn-prev {
        height: 28px;
        line-height: 28px;
        background: #F7F7F9;
        border: 1px solid #E5E5ED;
    }

    .el-pagination.is-background .el-pager li {
        height: 28px;
        line-height: 28px;
        background: #F7F7F9;
        border: 1px solid #E5E5ED;
    }

    .el-pagination.is-background .btn-next {
        height: 28px;
        line-height: 28px;
        background: #F7F7F9;
        border: 1px solid #E5E5ED;
    }

    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #002b9c;
    }

    .el-select .el-input__inner:focus {
        border-color: #002b9c;
    }

    /deep/ .el-select-dropdown__item .selected {
        color: #002b9c !important;
        font-weight: 700;
    }
}
* {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
    width: 100%;
    min-height: 100%;
    font-family: "Microsoft YaHei","SimHei";
    scroll-behavior: smooth;
}
@media screen and (max-width: 1200px) {
    html {
        overflow-y: hidden;
    }
}

.el-popover{
    min-width: 140px !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: 0px 10px 55px 5px rgba(0, 0, 0, 0.09) !important;
    z-index: 9 !important;
    padding: 18px 13px !important;
    p{
        margin-bottom: 8px;
        font-size: 12px;
        color: #828892;
        cursor: pointer;
        img{
            width: 14px;
            height: 14px;
            float: right;
            display: none;
        }
    }
    p:last-child{
      margin: 0;
    }
    p:hover{
      color: #19B0EA;
      text-indent: 10px;
      img{
        display: block;
      }
    }
}
.popper__arrow{
    display: none !important;
}
</style>
<script>
    if(window.location.href.indexOf('admin.slbqw')>-1){
        window['console']['log'] = function() {};
    }
    export default {
        created() {
            //在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem('store')) {
                this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))));
            }
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener('beforeunload', () => {
                if(sessionStorage.getItem('out')=='true'){
                    sessionStorage.removeItem('out');
                }else{
                    // if(sessionStorage.getItem('token')){
                        sessionStorage.setItem('store', JSON.stringify(this.$store.state));
                    // }
                }
            });
        }
    }
</script>
